import {exemptionTypes,exemptionStatus} from "./exemptions";

/**
 * defines the names of the various steps
 * in the wizard
 */
export const possibleWizardSteps = {
    dashboard:"dashboard",
    aknowledgement: "aknowledgement",
    formFields:"formfields",
    fileUpload:"fileupload",
    signature:"signature"
}
 
/**
 * Associates a real url for each wizard step
 */
export const stepToUrl = {
    [possibleWizardSteps.dashboard]: '/',
    [possibleWizardSteps.aknowledgement]: 'request/wizard/step1disclaimer',
    [possibleWizardSteps.formFields]: 'request/wizard/step2exemptionform',
    [possibleWizardSteps.fileUpload]: 'request/wizard/step3documentupload',
    [possibleWizardSteps.signature]: 'request/wizard/step4signature'
}

/*******************************************************************************************************
 * HELPER RULES (what ever repeats, a bit of abstractions)
 *******************************************************************************************************/
const nonAll = {
    [possibleWizardSteps.dashboard] : possibleWizardSteps.aknowledgement
};

const newApplicationMedical = {
    [possibleWizardSteps.dashboard] : possibleWizardSteps.fileUpload,
    [possibleWizardSteps.aknowledgement] : possibleWizardSteps.fileUpload,
    [possibleWizardSteps.fileUpload] : possibleWizardSteps.signature
};

const newApplicationReligious = {
    [possibleWizardSteps.dashboard] : possibleWizardSteps.formFields,
    [possibleWizardSteps.aknowledgement] : possibleWizardSteps.formFields,
    [possibleWizardSteps.formFields] : possibleWizardSteps.fileUpload,
    [possibleWizardSteps.fileUpload] : possibleWizardSteps.signature
};

const moreInfoApplicationMedical = {
    [possibleWizardSteps.dashboard] : possibleWizardSteps.fileUpload,
    [possibleWizardSteps.fileUpload] : possibleWizardSteps.dashboard
};

const moreInfoApplicationReligious = {
    [possibleWizardSteps.dashboard] : possibleWizardSteps.formFields,
    //should not happen [possibleWizardSteps.aknowledgement] : possibleWizardSteps.formFields,
    [possibleWizardSteps.formFields] : possibleWizardSteps.fileUpload,
    [possibleWizardSteps.fileUpload] : possibleWizardSteps.dashboard
};

// ---

const allInterimStatuses = {
    [exemptionTypes.medCovidVax] : newApplicationMedical,
    [exemptionTypes.medCovidBooster] : newApplicationMedical,
    [exemptionTypes.medFluVax] :newApplicationMedical,
    [exemptionTypes.medN95Fit] : newApplicationMedical,
    
    [exemptionTypes.relCovidVax] : newApplicationReligious,
    [exemptionTypes.relCovidBooster] : newApplicationReligious,
    [exemptionTypes.relFluVax] : newApplicationReligious,
    [exemptionTypes.relN95Fit] :newApplicationReligious

};

const pendingMoreInfoStatus = {
    [exemptionTypes.medCovidVax] : moreInfoApplicationMedical,
    [exemptionTypes.medCovidBooster] : moreInfoApplicationMedical,
    [exemptionTypes.medFluVax] :moreInfoApplicationMedical,
    [exemptionTypes.medN95Fit] : moreInfoApplicationMedical,
    
    [exemptionTypes.relCovidVax] : moreInfoApplicationReligious,
    [exemptionTypes.relCovidBooster] : moreInfoApplicationReligious,
    [exemptionTypes.relFluVax] : moreInfoApplicationReligious,
    [exemptionTypes.relN95Fit] :moreInfoApplicationReligious

};
/*******************************************************************************************************
 * EOF - HELPER RULES
 *******************************************************************************************************/



/**
 * Actual decision table - here sleeps the actual logic
 */
const actionMap = {
    [exemptionStatus.non.key] :{
        [exemptionTypes.medCovidVax] : nonAll,
        [exemptionTypes.medCovidBooster] : nonAll,
        [exemptionTypes.medFluVax] : nonAll,
        [exemptionTypes.medN95Fit] : nonAll,
        
        [exemptionTypes.relCovidVax] : nonAll,
        [exemptionTypes.relCovidBooster] :nonAll,
        [exemptionTypes.relFluVax] : nonAll,
        [exemptionTypes.relN95Fit] : nonAll

    }, //---------------------------------------------------------------------------------------------------------
    [exemptionStatus.draft.key] :allInterimStatuses, 
    
       //---------------------------------------------------------------------------------------------------------
    [exemptionStatus.newApplication.key] :{

    }, //---------------------------------------------------------------------------------------------------------
    [exemptionStatus.inReview.key] :{
    
    }, //---------------------------------------------------------------------------------------------------------
    [exemptionStatus.pendingLegal.key] : {

    }, //---------------------------------------------------------------------------------------------------------
    [exemptionStatus.approved.key] :{
        
    }, //---------------------------------------------------------------------------------------------------------
    [exemptionStatus.declined.key] :{
        
    }, //---------------------------------------------------------------------------------------------------------
    [exemptionStatus.tmpApproved.key] :{
        
    }, //---------------------------------------------------------------------------------------------------------
    [exemptionStatus.expired.key] :{
        
    }, //---------------------------------------------------------------------------------------------------------
    [exemptionStatus.pendingMoreInfo.key] : pendingMoreInfoStatus,
    
       //---------------------------------------------------------------------------------------------------------
    [exemptionStatus.updatedApplication.key] : {

    }, //---------------------------------------------------------------------------------------------------------
    [exemptionStatus.vaxComplete.key] :{
        
    }, //---------------------------------------------------------------------------------------------------------
    [exemptionStatus.notRequired.key] :{
        
    }, //---------------------------------------------------------------------------------------------------------
    [exemptionStatus.terminated.key] :{
        
    }  //---------------------------------------------------------------------------------------------------------
};



/**
 * This util function take's the user's current status and returns the link for the 
 * next step. Will return false if there is no link for next step
 * 
 * @param {string} ohRequestType : Exemption type (for example. medicalFuleVx)
 * @param {string} ohRequestStatus : The request status (draft,new ... etc)
 * @param {string} ohRequestCurrentStep : Where the user is currently in the wizard.
 */
export default function nextActionMatrix(ohRequestStatus,ohRequestType,ohRequestCurrentStep){
    return actionMap?.[ohRequestStatus]?.[ohRequestType]?.[ohRequestCurrentStep] ?? false;
}
